<nb-card class="dialog-card" [nbSpinner]="saving">
  <nb-card-header>
    <h4>{{ "pages.mcp.ack.title" | translate: { name: connector.name } }}</h4>
  </nb-card-header>

  <nb-card-body>
    <p class="intro">{{ "pages.mcp.ack.intro" | translate }}</p>

    <div class="scope">
      <span class="label">{{ "pages.mcp.ack.server" | translate }}</span>
      <code>{{ connector.server_url }}</code>
      <span class="label">{{ "pages.mcp.ack.tools" | translate: { count: enabledTools.length } }}</span>
      <ul>
        <li *ngFor="let tool of enabledTools">
          <code>{{ tool.agent_tool_name }}</code> — {{ tool.description_effective }}
        </li>
      </ul>
      <div class="no-tools" *ngIf="!enabledTools.length">
        <p class="hint hint--warning">{{ "pages.mcp.ack.noTools" | translate }}</p>
        <button *ngIf="availableCount" nbButton size="small" status="basic" type="button" (click)="enableAll()"
          [disabled]="saving" [nbTooltip]="'pages.mcp.tooltips.enableAll' | translate">
          <nb-icon icon="checkmark-square-2-outline"></nb-icon>
          {{ "pages.mcp.ack.enableAll" | translate: { count: availableCount } }}
        </button>
      </div>
    </div>

    <div
      class="notice"
      *ngFor="let n of notices"
      [class.is-missing]="attempted && !checked[n]"
    >
      <nb-checkbox [(ngModel)]="checked[n]" [ngModelOptions]="{ standalone: true }">
        <strong>{{ "pages.mcp.ack.notices." + n + ".title" | translate }}</strong>
      </nb-checkbox>
      <p>{{ "pages.mcp.ack.notices." + n + ".text" | translate }}</p>
    </div>

    <p class="hint">{{ "pages.mcp.ack.recorded" | translate }}</p>
    <p class="hint hint--warning" *ngIf="attempted && !allChecked">{{ "pages.mcp.ack.confirmAll" | translate }}</p>
    <p class="hint hint--warning" *ngIf="error">{{ error }}</p>
  </nb-card-body>

  <nb-card-footer>
    <button nbButton status="basic" size="small" type="button" (click)="close()">
      {{ "buttons.cancel" | translate }}
    </button>
    <button nbButton status="primary" size="small" type="button" (click)="confirm()" [disabled]="saving"
      [nbTooltip]="'pages.mcp.tooltips.ackConfirm' | translate">
      {{ "pages.mcp.ack.confirm" | translate }}
    </button>
  </nb-card-footer>
</nb-card>
